<template>
  <div
    id="overlay"
    class="overlay"
    :class="[
      'md:hidden',
      {
        // 'aside-collapsed': isMenuCollapsed,
        hidden: !isMenuCollapsed,
        block: isMenuCollapsed,
      },
    ]"
    @click="toggleMenu"
  ></div>
  <div
    class="fixed"
    :class="[
      'md:hidden aside-menu',
      {
        // 'aside-collapsed': isMenuCollapsed,
        hidden: !isMenuCollapsed,
        block: isMenuCollapsed,
      },
    ]"
  >
    <div
      :class="[
        'fixed overflow-y-scroll top-0 left-0 h-full aside-menu-overlay',
        { 'aside-menu-overlay-collapsed': isMenuCollapsed },
      ]"
    >
      <aside>
        <div>
          <div class="header ml-2">
            <!--            <btnMenuAsideOpenClose @click="toggleMenu" class="ml-2" />-->
            <IconComponent
              name="close"
              class="float-right cursor-pointer"
              config="menuAside"
              @click="toggleMenu"
            />
            <div class="w-full flex justify-center mb-2">
              <img class="logo" src="@/assets/imgs/app/logo-asidebar.png" />
            </div>
            <div class="w-full">
              <div class="py-1">
                <a
                  href="#"
                  class="flex font-red py-2 text-sm"
                  @click="logoutUser"
                >
                  <span class="mr-2">SAIR</span>
                  <arrowrightfrombracket fill="#D83139" width="15px" />
                </a>
              </div>
            </div>
            <p class="text-white text-sm font-bold">
              Bem vindo(a)
              <span class="uppercase">{{ props.nomeUsuario }}</span>
            </p>
            <p class="text-white text-sm">
              PERFIL:
              <span class="font-red text-sm uppercase">{{
                props.perfilUsuario
              }}</span>
            </p>
          </div>
          <nav id="aside-nav-menu" class="menu">
            <ul>
              <li
                v-for="(navItem, index, key) in navMenuItems"
                :key="index"
                :class="{ active: navItem.active }"
              >
                <template v-if="navItem.submenu && navItem.submenu.length > 0">
                  <div class="grid grid-cols-12 px-2 py-1" :id="key">
                    <div class="col-span-1 nav-menu-item-icon">
                      <IconComponent
                        :name="navItem.icon"
                        class="mr-2 w-[20px]"
                        config="menuAside"
                      />
                    </div>
                    <div
                      :class="[
                        'col-span-11 nav-menu-item-label',
                        { 'nav-menu-item-label-collapsed': isMenuCollapsed },
                      ]"
                    >
                      <btnMenuMainItem :text="navItem.label" :id="index">
                        <template #dropdownItems>
                          <ul>
                            <li
                              v-for="subItem in navItem.submenu"
                              :key="subItem.label"
                              @click="() => selectMenuItemMobile(subItem)"
                            >
                              <RouterLink v-if="subItem.to" :to="subItem.to">
                                <a :class="{ 'font-bold': subItem.active }">{{
                                  subItem.label
                                }}</a>
                              </RouterLink>
                              <a
                                v-else
                                :class="{ 'font-bold': subItem.active }"
                                >{{ subItem.label }}</a
                              >
                            </li>
                          </ul>
                        </template>
                      </btnMenuMainItem>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <RouterLink
                    v-if="navItem.to"
                    :to="navItem.to"
                    @click="btnDoubleActionClick(navItem)"
                  >
                    <div
                      :class="[
                        'grid grid-cols-12 px-2 py-1',
                        { 'font-extrabold': navItem.active },
                      ]"
                    >
                      <div class="col-span-1 nav-menu-item-icon">
                        <IconComponent
                          :name="navItem.icon"
                          class="mr-2 w-[20px]"
                          config="menuAside"
                        />
                      </div>
                      <div
                        :class="[
                          'col-span-11 nav-menu-item-label',
                          { 'nav-menu-item-label-collapsed': isMenuCollapsed },
                        ]"
                      >
                        <span
                          class="px-2 shadow-sm text-white py-1 text-center font-light"
                          >{{ navItem.label }}</span
                        >
                      </div>
                    </div>
                  </RouterLink>
                </template>
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { useAsideFunctions } from "@/composables/useAsideFunctions";
import IconComponent from "@/components/app/icons/IconComponent.vue";
import btnMenuMainItem from "@/components/app/buttons/btnMenuMainItem.vue";
import { RouterLink } from "vue-router";
import arrowrightfrombracket from "@/components/app/icons/arrow-right-from-bracket.vue";
import { useToggleAll } from "@/composables/useToggleAll";
import { useLogout } from "@/composables/useLogout";

const { logoutUser } = useLogout();

const props = defineProps({
  nomeUsuario: {
    type: String,
    default: "USUÁRIO",
  },
  perfilUsuario: {
    type: String,
    default: "ANALISTA",
  },
});
const { closeAll } = useToggleAll();
const { navMenuItems, isMenuCollapsed, toggleMenu, selectMenuItemMobile } =
  useAsideFunctions();

function btnDoubleActionClick(item) {
  closeAll();
  selectMenuItemMobile(item);
}
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Fundo semitransparente */
  z-index: 998; /* Abaixo do aside-menu */
}

.aside-menu {
  width: calc(80vw);
  background-color: #032571;
  color: #ffffff;
  min-height: 100vh;
  transition: width 0.3s;
  z-index: 999;
}

.aside-menu-overlay {
  width: calc(80vw);
}

.aside-menu-overlay-collapsed {
  width: calc(80vw);
}

.aside-collapsed {
  width: 80px;
}

.header {
  align-items: center;
  padding: 16px 16px 0px 16px;
}

.logo {
  width: 70%;
}

.logo-collapsed {
  display: none;
}

.menu {
  padding: 16px 0;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu li {
  padding: 16px 16px;
}

.menu li.active > a {
  font-weight: bold;
}

.nav-menu-item-icon {
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.nav-menu-item-label {
  display: inline-block;
  transition: opacity 0.3s;
  opacity: 1;
}
</style>
